import PatientsListContainer from './patients-list-container';

export default PatientsListContainer;
